import React from 'react';

import { Controller, useFormContext } from 'react-hook-form';

import { IFields } from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/MainFilters.types';
import classes from 'components/Dashboards/Program/Dashboard/ProgramDashboardComponents/Battlecards/MainFilters/components/Filters/Filters.module.scss';
import { Select } from 'components/DesignSystem/Select';

export const Important = ({ options, onFiltersChanged, isLoading }) => {
    const { control } = useFormContext<IFields>();

    return (
        <div className={classes.selectWrapper}>
            <span className={classes.title}>Important</span>
            <Controller
                render={({ field }) => (
                    <Select<ISelectOption<string>>
                        id={'battlecards-filters-important'}
                        {...field}
                        onChange={(newValue) => {
                            field.onChange(newValue);
                            onFiltersChanged({ [field.name]: newValue });
                        }}
                        options={options}
                        isClearable={true}
                        isLoading={isLoading}
                    />
                )}
                name={`important`}
                control={control}
            />
        </div>
    );
};
